import { Interactions } from "../core/providers/interactions.provider.tsx";
import { usePractice } from "../core/providers/practice.provider.tsx";
import {
  appointmentView,
  appointmentsForPatient,
} from "../agenda/appointments.ts";
import { formatHour, todayLocal, toISODate } from "../agenda/date-utils.ts";

export function PatientRdvWidget() {
  const { current } = Interactions.usePatient();
  const { practice } = usePractice();

  if (!current) {
    return (
      <p className="px-1 text-xs text-sf-text-muted">
        Aucun patient sélectionné.
      </p>
    );
  }

  const todayIso = toISODate(todayLocal());
  const upcoming = appointmentsForPatient(
    current.uuid,
    practice.uuid,
    todayLocal(),
    6,
  ).map((a) => appointmentView(a));

  const todaySlots = upcoming.filter((a) => a.date === todayIso);
  const nextSlots = upcoming.filter((a) => a.date !== todayIso);

  return (
    <div className="flex flex-col gap-3">
      <section>
        <h4 className="mb-1.5 text-[10.5px] font-bold uppercase tracking-wide text-sf-text-muted">
          Aujourd'hui
        </h4>
        {todaySlots.length === 0 ? (
          <p className="text-xs text-sf-text-muted">Pas de RDV aujourd'hui.</p>
        ) : (
          <ul className="flex flex-col gap-1">
            {todaySlots.map((s) => (
              <li
                key={s.id}
                className="flex items-center justify-between rounded-md border border-sf-primary-100 bg-sf-primary-50 px-2.5 py-2 text-xs"
              >
                <span className="font-semibold tabular-nums text-sf-primary">
                  {formatHour(s.start)}
                </span>
                <span className="truncate font-medium text-sf-text">
                  {s.motif}
                </span>
                <span className="text-sf-text-muted">
                  {Math.round(s.dur * 60)} min
                </span>
              </li>
            ))}
          </ul>
        )}
      </section>
      {nextSlots.length > 0 && (
        <section>
          <h4 className="mb-1.5 text-[10.5px] font-bold uppercase tracking-wide text-sf-text-muted">
            Prochains RDV
          </h4>
          <ul className="flex flex-col gap-1">
            {nextSlots.map((s) => (
              <li
                key={s.id}
                className="flex items-center justify-between rounded-md border border-sf-border px-2.5 py-2 text-xs"
              >
                <span className="tabular-nums text-sf-text-muted">
                  {new Date(s.date).toLocaleDateString("fr-FR", {
                    day: "numeric",
                    month: "short",
                  })}{" "}
                  {formatHour(s.start)}
                </span>
                <span className="truncate font-medium text-sf-text">
                  {s.motif}
                </span>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
